module.exports = __webpack_public_path__ + "img/guerrilla.c8fd88a6.png";